import React from 'react';
import { Reveal } from './ui/Reveal';
import { HeartHandshake, AlertCircle } from 'lucide-react';
export function AboutFlorencia() {
  return <section className="py-20 bg-white" data-id="element-12">
      <div className="max-w-4xl mx-auto px-6" data-id="element-13">
        <Reveal data-id="element-14">
          <div className="text-center mb-16" data-id="element-15">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-16">
              Hola, soy Florencia Guevara
            </h2>
            <p className="text-xl text-brand-sage font-medium mb-8" data-id="element-17">
              Lic. en Nutrición y Personal Trainer
            </p>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-12" data-id="element-18">
          <Reveal delay={0.1} data-id="element-19">
            <div className="bg-brand-sand p-8 rounded-2xl h-full" data-id="element-20">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mb-6 shadow-sm" data-id="element-21">
                <AlertCircle className="w-6 h-6 text-brand-coral" data-id="element-22" />
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-23">El problema real</h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-24">
                He visto a cientos de mujeres frustradas por dietas extremas,
                gastando dinero en suplementos inútiles y sufriendo el temido
                efecto rebote. La industria nos ha hecho creer que para perder
                peso hay que sufrir, pero eso solo daña tu metabolismo y tu
                salud mental.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.2} data-id="element-25">
            <div className="bg-brand-forest text-white p-8 rounded-2xl h-full" data-id="element-26">
              <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center mb-6" data-id="element-27">
                <HeartHandshake className="w-6 h-6 text-brand-sage" data-id="element-28" />
              </div>
              <h3 className="text-xl font-bold mb-4" data-id="element-29">Mi compromiso contigo</h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-30">
                Creé "24 Pasos a Tu Peso Ideal" para ofrecerte una salida. Un
                camino basado en ciencia, empatía y hábitos reales. Mi objetivo
                no es que pierdas 10 kilos en una semana, sino que construyas un
                cuerpo sano y una relación en paz con la comida para toda la
                vida.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}